export function isOneOf<T>( value:T, option:T, ...options:T[] ):boolean
{
  if ( option === value )
  {
    return true;
  }

  for ( let i = 0; i < options.length; i++ )
  {
    if ( options[ i ] === value )
    {
      return true;
    }
  }

  return false; 
}